module.exports = __webpack_public_path__ + "static/media/healthPatri.cbd10563.svg";